import React, { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import CardWrapper from "./CardWrapper"
import PassengersImg from "../../../../../assets/avia/search/passagers.png"
import PassengerModal from "./PassengerModal"
import { useDispatch, useSelector } from "react-redux"
import {
  selectAviaSearchPassengers,
  setAviaSearchParams,
} from "../../../../../app/reducers/book/aviaSearchSlice"
import { useGetFiltersMetaQuery } from "../../../../../app/services/book/filters"

const DEFAULT_MAX_PASSENGERS = {
  adults: 6,
  children: 3,
  infants: 11,
}

const PassengersCard = ({ count }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const passengers = useSelector(selectAviaSearchPassengers)

  const { data: metaData } = useGetFiltersMetaQuery()

  const settingsLimits = metaData?.settings?.avia_search_max_passengers

  const maxPassengers = {
    adults: Number(settingsLimits?.adults) || DEFAULT_MAX_PASSENGERS.adults,
    children: Number(settingsLimits?.children) || DEFAULT_MAX_PASSENGERS.children,
    infants: Number(settingsLimits?.infants) || DEFAULT_MAX_PASSENGERS.infants,
  }

  const [isOpenModal, setIsOpenModal] = useState(false)
  const cardRef = useRef(null)

  return (
    <CardWrapper>
      <div
        onClick={() => setIsOpenModal(true)}
        ref={cardRef}
        className="flex flex-col justify-center h-[45px] overflow-visible relative cursor-pointer min-w-0 text-sm"
      >
        <span className="text-text-secondary whitespace-nowrap leading-none">
          {t("admin.passengers")}
        </span>
        <div className="flex items-center gap-2 mt-1">
          <img src={PassengersImg} alt="passenger card icon" className="shrink-0 w-4 h-4" />
          <span className="text-black whitespace-nowrap">{count}</span>
        </div>
      </div>
      <PassengerModal
        showModal={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        maxPassengers={maxPassengers}
      />
    </CardWrapper>
  )
}

export default PassengersCard
